import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import FormControl from '@material-ui/core/FormControl';
import { Select, MenuItem, InputLabel } from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment/locale/pt-br';
import FormData from 'form-data';
import { useDispatch } from 'react-redux';

import styles from './styles.module.scss';
import {
  getParceiros,
  getRegional,
  getFilial,
  getTipoRelatorio,
  getRelatorio,
  getListaAcao,
  getListaTreinamento,
} from '../../services/api-auto';

import {
  showMsgW as showMsgWAction,
  showMsgE as showMsgEAction,
  showMsgS as showMsgSAction,
} from '../../store/actions/snackbarActions.js';
import { saveAs } from 'file-saver';

import ModalLoading from '../../components/ModalLoading';
import { EmojiEmotionsSharp } from '@material-ui/icons';

const AdicionarCampanha = () => {
  const dispatch = useDispatch();
  const showMsgW = (msg) => dispatch(showMsgWAction(msg));
  const showMsgE = (msg) => dispatch(showMsgEAction(msg));
  const showMsgS = (msg) => dispatch(showMsgSAction(msg));

  const history = useHistory();

  const [campanha, setCampanha] = useState({});
  const [treinamento, setTreinamento] = useState({});
  const [treinamentoList, setTreinamentoList] = useState([]);
  const [campanhaList, setCampanhaList] = useState([]);
  const [regional, setRegional] = useState([]);
  const [filial, setFilial] = useState([]);

  const [periodoDe, setPeriodoDe] = useState();
  const [periodoAte, setPeriodoAte] = useState();

  const [tipos, setTipos] = useState([]);
  const [parceiros, setParceiros] = useState([]);

  const [tiposSelecionado, setTiposSelecionado] = useState('');
  const [periodoSelecionado, setPeriodoSelecionado] = useState('');
  const [periodoAteSelecionado, setPeriodoAteSelecionado] = useState('');

  const [configuracaoLojasFinal, setConfiguracaoLojasFinal] = useState([]);
  const [indicarErros, setIndicarErros] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  /** */

  const [regionalSelecionado, setRegionalSelecionado] = useState('todos');
  const [filialSelecionado, setFilialSelecionado] = useState('todos');
  const [parceiroSelecionado, setParceiroSelecionado] = useState('todos');
  const [tiposRelatorios, setTiposRelatorios] = useState([]);
  const [data, setData] = useState({
    tipo: 0,
    tipoParceiro: 'todos',
    tipoRelatorioAcesso: 0,
    status: 0,
  });

  const carregarTipoRelatorio = async () => {
    const info = await getTipoRelatorio();
    setTiposRelatorios(info);
  };

  const getCampanhasList = async () => {
    const info = await getListaAcao({
      periodoFinal: moment(periodoAte).endOf('month').subtract(1, 'days'),
      periodoInicial: moment(periodoDe).startOf('month'), // Corrigido o nome da propriedade
    });
    setCampanhaList(info);
  };
  
  useEffect(() => {
    getCampanhasList();
  }, [periodoDe, periodoAte]);

  const carregarRegional = async () => {
    const info = await getRegional();
    setRegional(info);
  };

  const carregarFilial = async () => {
    setModalLoading(true);
    try {
      const info = await getFilial(regionalSelecionado);
      setFilial(info);
    } catch (e) {
      showMsgE('Erro ao carregar Filiais');
    } finally {
      setModalLoading(false);
    }
  };

  const getTreinamentoList = async () => {
    const info = await getListaTreinamento();
    setTreinamentoList(info.data);
  };


  const carregarParceiro = async () => {
    setModalLoading(true);
    try {
      const info = await getParceiros(regionalSelecionado, filialSelecionado);
      setParceiros(info);
    } catch (e) {
      showMsgE('Erro ao carregar Parceiros');
    } finally {
      setModalLoading(false);
    }
  };

  const start = async () => {
    setModalLoading(true);
    try {
      await carregarRegional();
      await carregarTipoRelatorio();
      await getTreinamentoList();
    } catch (e) {
      showMsgE('Erro ao carregar dados');
    } finally {
      setModalLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  useEffect(() => {
    if (regionalSelecionado) {
      carregarFilial();
    }
  }, [regionalSelecionado]);

  useEffect(() => {
    if (filialSelecionado) {
      carregarParceiro();
    }
  }, [filialSelecionado]);

  const enviar = async () => {
    setModalLoading(true);
    try {
      let formdata = createSenderForm();
      if (data.tipoRelatorioAcesso === 1) {
        formdata.periodoInicial = null;
        formdata.periodoFinal = null;
      }
      let info = await getRelatorio(formdata);
      let nome = tiposRelatorios.find(
        (e) => e.id == formdata.tipoRelatorio
      ).nome;
      saveAs(info.data, nome + `.xlsx`);
    } catch (e) {
      const error = JSON.parse(await e.response.data.text());
      console.log(error);
      showMsgE(error.message);
    } finally {
      setModalLoading(false);
    }
  };

  const createSenderForm = () => {
    let formdata = {
      tipoRelatorio: data.tipo,
      campanha: data.tipo === 5 || data.tipo === 13 ? campanha.idAcao : null,
      periodoInicial:
        data.tipo === 9 || data.tipo === 11
          ? moment(periodoDe).format('YYYY-MM-DD')
          : data.tipo === 12
          ? null
          : data.tipo === 13
          ? moment(periodoDe).format('YYYY-MM-01')
          : null,
      periodoFinal:
        data.tipo === 9 || data.tipo === 11
          ? moment(periodoAte).format('YYYY-MM-DD')
          : data.tipo === 12
          ? null
          : data.tipo === 13
          ? moment(periodoAte).endOf('month').format('YYYY-MM-DD')
          : null,
      regional: regionalSelecionado !== 'todos' ? regionalSelecionado : null,
      filial: filialSelecionado !== 'todos' ? filialSelecionado : null,
      tipoParceiro: data.tipoParceiro === 'todos' ? null : data.tipoParceiro,
      tipoRelatorioAcesso: data.tipo === 9 ? data.tipoRelatorioAcesso : null,
      status: data.tipo === 11 ? data.status : null,
      treinamento:
        data.tipo === 12
          ? treinamento !== 'todos'
            ? treinamento.treinamentoId
            : '00000000-0000-0000-0000-000000000000'
          : null,
    };

    return formdata;
  };

  /** */

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        Relatórios
        <button
          className={styles.backButton}
          onClick={() => {
            history.goBack();
          }}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
      </div>
      <div className={styles.blueBackground}>
        <div className={styles.content}>
          <div className={styles.card}>
            <FormControl fullWidth>
              <InputLabel
                id="select-tipo-label"
                style={{ paddingLeft: '12px' }}
              >
                Tipo de relatório
              </InputLabel>
              <Select
                labelId="select-tipo-label"
                label="Tipo de ação"
                onChange={(e) => {
                  setData({ ...data, tipo: e.target.value });
                }}
                value={data.tipo}
                variant="filled"
                className="customFilledInput"
              >
                {tiposRelatorios.map((tipo) => {
                  return <MenuItem value={tipo.id}>{tipo.nome}</MenuItem>;
                })}
              </Select>
            </FormControl>
            {data.tipo === 5 ||
              (data.tipo === 13 && (
                <>
                  <FormControl className={styles.selects}>
                    <MuiPickersUtilsProvider
                      locale="pt-br"
                      libInstance={moment}
                      utils={MomentUtils}
                    >
                      <KeyboardDatePicker
                        views={['year', 'month']}
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        label="De"
                        format="MMMM/yyyy"
                        value={periodoDe}
                        InputAdornmentProps={{ position: 'start' }}
                        onChange={(novaData) => {
                          setPeriodoDe(novaData);
                        }}
                        className="customFilledInput"
                        error={false}
                        invalidDateMessage="Data em formato inválido."
                        maxDateMessage="Data não deve ser maior que a data máxima."
                        minDateMessage="Data não deve ser menor que a data mínima."
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                  <FormControl className={styles.selects}>
                    <MuiPickersUtilsProvider
                      locale="pt-br"
                      libInstance={moment}
                      utils={MomentUtils}
                    >
                      <KeyboardDatePicker
                        views={['year', 'month']}
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        label="Até"
                        format="MMMM/yyyy"
                        value={periodoAte}
                        InputAdornmentProps={{ position: 'start' }}
                        onChange={(novaData) => {
                          setPeriodoAte(novaData);
                        }}
                        className="customFilledInput"
                        error={false}
                        invalidDateMessage="Data em formato inválido."
                        maxDateMessage="Data não deve ser maior que a data máxima."
                        minDateMessage="Data não deve ser menor que a data mínima."
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                  <FormControl>
                    <InputLabel id="select-tipo-label" className={styles.label}>
                      Campanha
                    </InputLabel>
                    <Select
                      disabled={!periodoDe || !periodoAte}
                      labelId="select-tipo-label"
                      label="Ação"
                      onChange={(e) => {
                        setCampanha(e.target.value);
                      }}
                      value={campanha}
                      variant="filled"
                      className="customFilledInput"
                    >
                      {campanhaList.map((item) => {
                        return (
                          <MenuItem value={item} key={item.idAcao}>
                            {item.nome}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </>
              ))}
            {data.tipo !== 0 &&
              data.tipo !== 4 &&
              data.tipo !== 6 &&
              data.tipo !== 7 &&
              data.tipo !== 9 &&
              data.tipo !== 11 &&
              data.tipo !== 12 &&
              data.tipo !== 10 &&
              data.tipo !== 13 && 
              data.tipo !== 14 &&(
                <FormControl className={styles.selects}>
                  <InputLabel
                    id="select-status-label"
                    className={styles.selectsLabel}
                  >
                    Regional
                  </InputLabel>
                  <Select
                    labelId="select-status-label"
                    label="Status"
                    onChange={(e) => {
                      setRegionalSelecionado(e.target.value);
                    }}
                    value={regionalSelecionado}
                    variant="filled"
                    className="customFilledInput"
                  >
                    <MenuItem value="todos">Todos</MenuItem>
                    {regional.map((regiao) => {
                      return (
                        <MenuItem value={regiao} key={regiao}>
                          {regiao}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              )}
            {data.tipo !== 0 &&
              data.tipo !== 4 &&
              data.tipo !== 6 &&
              data.tipo !== 7 &&
              data.tipo !== 9 &&
              data.tipo !== 11 &&
              data.tipo !== 12 &&
              data.tipo !== 10 &&
              data.tipo !== 13 &&
              data.tipo !== 14 && (
                <FormControl className={styles.selects}>
                  <InputLabel
                    id="select-status-label"
                    className={styles.selectsLabel}
                  >
                    Filial
                  </InputLabel>
                  <Select
                    labelId="select-status-label"
                    label="Status"
                    onChange={(e) => {
                      setFilialSelecionado(e.target.value);
                    }}
                    value={filialSelecionado}
                    variant="filled"
                    className="customFilledInput"
                  >
                    <MenuItem value="todos">Todos</MenuItem>
                    {filial.map((info) => {
                      return (
                        <MenuItem value={info} key={info}>
                          {info}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              )}
            {/*<FormControl className={styles.selects}>
                                <InputLabel id="select-status-label" className={styles.selectsLabel}>
                                Loja
                                </InputLabel>
                                <Select
                                    labelId='select-status-label'
                                    label="Status"
                                    onChange={(e)=>{ setParceiroSelecionado( e.target.value )}}
                                    value={parceiroSelecionado}
                                    variant="filled"
                                    className="customFilledInput"
                                >
                                    <MenuItem value="todos">Todos</MenuItem>
                                    {parceiros.map( (parceiro) => {
                                        return (
                                            <MenuItem value={parceiro.nomeParceiro} key={parceiro.nomeParceiro}>
                                                {parceiro.nomeParceiro}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                                </FormControl>*/}
            {data.tipo !== 0 &&
              data.tipo !== 4 &&
              data.tipo !== 6 &&
              data.tipo !== 7 &&
              data.tipo !== 9 &&
              data.tipo !== 11 &&
              data.tipo !== 12 &&
              data.tipo !== 10 &&
              data.tipo !== 13 &&
              data.tipo !== 14 && (
                <FormControl fullWidth>
                  <InputLabel
                    id="select-tipo-label"
                    style={{ paddingLeft: '12px' }}
                  >
                    Tipo de parceiro
                  </InputLabel>
                  <Select
                    labelId="select-tipo-label"
                    label="Tipo de ação"
                    onChange={(e) => {
                      setData({ ...data, tipoParceiro: e.target.value });
                    }}
                    value={data.tipoParceiro}
                    variant="filled"
                    className="customFilledInput"
                  >
                    <MenuItem value={'todos'}>Todos</MenuItem>
                    <MenuItem value={1}>Concessionaria</MenuItem>
                    <MenuItem value={2}>Loja</MenuItem>
                    <MenuItem value={3}>F&I</MenuItem>
                  </Select>
                </FormControl>
              )}
            {data.tipo === 9 && (
              <div className="d-flex flex-md-row flex-column">
                <FormControl fullWidth>
                  <InputLabel
                    id="select-tipo-label"
                    style={{ paddingLeft: '12px' }}
                  >
                    Tipo de parceiro
                  </InputLabel>
                  <Select
                    labelId="select-tipo-label"
                    label="Tipo de ação"
                    onChange={(e) => {
                      setData({ ...data, tipoRelatorioAcesso: e.target.value });
                    }}
                    value={data.tipoRelatorioAcesso}
                    variant="filled"
                    className="customFilledInput"
                  >
                    <MenuItem value={0}>Diario</MenuItem>
                    <MenuItem value={1}>Total</MenuItem>
                  </Select>
                </FormControl>
                {data.tipoRelatorioAcesso == 0 && (
                  <>
                    <FormControl className={styles.selects}>
                      <MuiPickersUtilsProvider
                        locale="pt-br"
                        libInstance={moment}
                        utils={MomentUtils}
                      >
                        <KeyboardDatePicker
                          views={['year', 'month']}
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          label="De"
                          format="DD/MM/YYYY"
                          value={periodoDe}
                          InputAdornmentProps={{ position: 'start' }}
                          onChange={(novaData) => {
                            setPeriodoDe(novaData);
                          }}
                          className="customFilledInput"
                          error={false}
                          invalidDateMessage="Data em formato inválido."
                          maxDateMessage="Data não deve ser maior que a data máxima."
                          minDateMessage="Data não deve ser menor que a data mínima."
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl className={styles.selects}>
                      <MuiPickersUtilsProvider
                        locale="pt-br"
                        libInstance={moment}
                        utils={MomentUtils}
                      >
                        <KeyboardDatePicker
                          views={['year', 'month']}
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          label="Até"
                          format="DD/MM/YYYY"
                          value={periodoAte}
                          InputAdornmentProps={{ position: 'start' }}
                          onChange={(novaData) => {
                            setPeriodoAte(novaData);
                          }}
                          className="customFilledInput"
                          error={false}
                          invalidDateMessage="Data em formato inválido."
                          maxDateMessage="Data não deve ser maior que a data máxima."
                          minDateMessage="Data não deve ser menor que a data mínima."
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </>
                )}
              </div>
            )}

            {data.tipo === 11 && (
              <div className="d-flex flex-md-row flex-column">
                <FormControl fullWidth>
                  <InputLabel
                    id="select-tipo-label"
                    style={{ paddingLeft: '12px' }}
                  >
                    Status
                  </InputLabel>

                  <Select
                    labelId="select-tipo-label"
                    label="Tipo de ação"
                    onChange={(e) => {
                      setData({ ...data, status: e.target.value });
                    }}
                    value={data.status}
                    variant="filled"
                    className="customFilledInput"
                  >
                    <MenuItem value={0}>Inativo</MenuItem>
                    <MenuItem value={1}>Ativo</MenuItem>
                  </Select>
                </FormControl>
                {data.tipoRelatorioAcesso == 0 && (
                  <>
                    <FormControl className={styles.selects}>
                      <MuiPickersUtilsProvider
                        locale="pt-br"
                        libInstance={moment}
                        utils={MomentUtils}
                      >
                        <KeyboardDatePicker
                          views={['year', 'month']}
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          label="De"
                          format="DD/MM/YYYY"
                          value={periodoDe}
                          InputAdornmentProps={{ position: 'start' }}
                          onChange={(novaData) => {
                            setPeriodoDe(novaData);
                          }}
                          className="customFilledInput"
                          error={false}
                          invalidDateMessage="Data em formato inválido."
                          maxDateMessage="Data não deve ser maior que a data máxima."
                          minDateMessage="Data não deve ser menor que a data mínima."
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl className={styles.selects}>
                      <MuiPickersUtilsProvider
                        locale="pt-br"
                        libInstance={moment}
                        utils={MomentUtils}
                      >
                        <KeyboardDatePicker
                          views={['year', 'month']}
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          label="Até"
                          format="DD/MM/YYYY"
                          value={periodoAte}
                          InputAdornmentProps={{ position: 'start' }}
                          onChange={(novaData) => {
                            setPeriodoAte(novaData);
                          }}
                          className="customFilledInput"
                          error={false}
                          invalidDateMessage="Data em formato inválido."
                          maxDateMessage="Data não deve ser maior que a data máxima."
                          minDateMessage="Data não deve ser menor que a data mínima."
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </>
                )}
              </div>
            )}

            {data.tipo === 12 && (
              <div className="d-flex flex-md-row flex-column">
                <FormControl fullWidth>
                  <InputLabel id="select-tipo-label" className={styles.label}>
                    Treinamento
                  </InputLabel>
                  <Select
                    labelId="select-tipo-label"
                    label="Treinamento"
                    onChange={(e) => {
                      setTreinamento(e.target.value);
                    }}
                    value={treinamento}
                    variant="filled"
                    className="customFilledInput"
                  >
                    <MenuItem value="todos">Todos</MenuItem>
                    {treinamentoList.map((item) => {
                      return (
                        <MenuItem value={item} key={item.treinamentoid}>
                          {item.titulo}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            )}

            <button className={styles.salvar} onClick={enviar}>
              Gerar Relatório
            </button>
          </div>
        </div>
      </div>
      <ModalLoading open={modalLoading} size="lg" />
    </div>
  );
};

export default AdicionarCampanha;
